import { APICore } from "helpers/api/apiCore";
import { FilterMetadata } from "redux/types";
import config from "../../config";
import { CancelPayableCharge } from "./types";

const api = new APICore();

function fetchPayableChargesApi(params: FilterMetadata) {
  const baseUrl = `${config.BACKEND_BASE_URL}/payable-charges`;
  return api.get(`${baseUrl}`, params);
}

function fetchPayableChargeApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/payable-charges/${params}`;
  return api.get(`${baseUrl}`, {});
}

function createPayableChargeApi(params: any) {
  let backendApiUrl = "";

  let apiData: any = {
    programmeExternalId: params?.programme ? params?.programme : "",
    borrowerExternalId: params?.borrowerExternalId ? params?.borrowerExternalId : "",
    chargeType: params?.payableChargeType ? params?.payableChargeType : "",
    gstPercentage: params?.gstPercentage ?? 0,
    amountWithoutGst: params?.amountWithoutGst ?? 0,
    totalAmount: params?.amountWithoutGst ?? 0,
    comment: params?.comment ? params?.comment : null,
    valueDate: params?.valueDate ? params?.valueDate : "",
  };

  if (params.exposureOn === "Anchor") {
    apiData.customerRelationExternalId = null
  }

  if (params.exposureOn === "CounterParty") {
    apiData.customerRelationExternalId = params?.customerRelationExternalId ? params?.customerRelationExternalId : ""
  }

  if (!params.draft) {
    apiData.makerRemarks = params.makerRemarks ? params.makerRemarks.trim() : "";

    backendApiUrl = `${config.BACKEND_BASE_URL}/payable-charges`;
  } else {
    backendApiUrl = `${config.BACKEND_BASE_URL}/payable-charges?draft=${params.draft}`;
  }
  const baseUrl = backendApiUrl;
  return api.create(`${baseUrl}`, apiData);

}

function updatePayableChargeApi(params: any) {
  let backendApiUrl = "";


  let apiData: any = {
    programmeExternalId: params?.programmeExternalId ? params?.programmeExternalId : "",
    borrowerExternalId: params?.borrowerExternalId ? params?.borrowerExternalId : "",
    chargeType: params?.payableChargeType ? params?.payableChargeType : "",
    gstPercentage: params?.gstPercentage ? params?.gstPercentage : 0,
    amountWithoutGst: params?.amountWithoutGst ? params?.amountWithoutGst : 0,
    gstAmount: params?.gstAmount ? params?.gstAmount : 0,
    totalAmount: params?.totalAmount ? params?.totalAmount : "",
    comment: params?.comment ? params?.comment : null,
    valueDate: params?.valueDate ? params?.valueDate : "",
  };


  if (params.customerRelationExternalId === null) {
    apiData.customerRelationExternalId = null
  }else {
    apiData.customerRelationExternalId = params?.customerRelationExternalId ? params?.customerRelationExternalId : ""
  }

  if (!params.draft) {
    apiData.makerRemarks = params.makerRemarks ? params.makerRemarks.trim() : "";
    backendApiUrl = `${config.BACKEND_BASE_URL}/payable-charges/${params.externalId}`;
  } else {
    backendApiUrl = `${config.BACKEND_BASE_URL}/payable-charges/${params.externalId}?draft=${params.draft}`;
  }

  const baseUrl = backendApiUrl;
  return api.update(`${baseUrl}`, apiData);
}

function fetchPayableChargeVersionApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/payable-charges/${params}/versions`;
  return api.get(`${baseUrl}`, params);
}


function deletePayableChargeApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/payable-charges/${params}`;
  return api.delete(`${baseUrl}`);
}


function fetchPayableChargeVersionDetailsApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/payable-charges/${params?.externalID}/versions/${params?.internalID}`;
  return api.get(`${baseUrl}`, {});
}

function fetchPayableChargeLatestVersionApi(params: any) {
  const baseUrl = `${config.BACKEND_BASE_URL}/payable-charges/${params?.externalId}/latestVersion`;
  return api.get(`${baseUrl}`, {});
}



function approvePayableChargeApi(params: any) {
  let remarks = {
    checkerRemarks: params.checkerRemarks.trim()
  };
  let externalId = params.externalId;
  const baseUrl = `${config.BACKEND_BASE_URL}/payable-charges/${externalId}/approve`;
  return api.updatePatch(`${baseUrl}`, remarks);
}
function rejectPayableChargeApi(params: any) {
  let remarks = {
    checkerRemarks: params.checkerRemarks.trim()
  };

  const baseUrl = `${config.BACKEND_BASE_URL}/payable-charges/${params?.externalId}/reject`;
  return api.updatePatch(`${baseUrl}`, remarks);
}

function blockPayableChargeApi(params: any) {
  const param = {
    inactiveReason: params.inactiveReason.trim()
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/payable-charges/${params.id}/block`;
  return api.updatePatch(`${baseUrl}`, param);
}

function freezePayableChargeApi(params: any) {
  const param = {
    inactiveReason: params.inactiveReason.trim()
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/payable-charges/${params.id}/freeze`;
  return api.updatePatch(`${baseUrl}`, param);
}

function unFreezePayableChargeApi(params: any) {
  const param = {
    inactiveReason: params.inactiveReason.trim()
  };
  const baseUrl = `${config.BACKEND_BASE_URL}/payable-charges/${params.id}/unfreeze`;
  return api.updatePatch(`${baseUrl}`, param);
}

function cancelPayableChargeApi(params: CancelPayableCharge) {
  const baseUrl = `${config.BACKEND_BASE_URL}/payable-charges/${params.chargesExternalId}/cancel`;
  return api.updatePatch(`${baseUrl}`, params.payload);
}

export {
  fetchPayableChargesApi,
  fetchPayableChargeApi,
  createPayableChargeApi,
  updatePayableChargeApi,
  fetchPayableChargeVersionApi,
  approvePayableChargeApi,
  rejectPayableChargeApi,
  blockPayableChargeApi,
  freezePayableChargeApi,
  unFreezePayableChargeApi,
  fetchPayableChargeVersionDetailsApi,
  fetchPayableChargeLatestVersionApi,
  deletePayableChargeApi,
  cancelPayableChargeApi
};
